import { http } from '@haohan/clw-utils'

const URL = '/api/v1/projects'

// 新增代码片段
export function postCodeSnippet(projectId: string, data: any) {
  return http.request({
    method: 'post',
    url: `${URL}/${projectId}/code-snippet`,
    data
  })
}

// 修改代码片段
export function putCodeSnippet(projectId: string, data: any, id: any) {
  return http.request({
    method: 'put',
    url: `${URL}/${projectId}/code-snippet/${id}`,
    data
  })
}

// 查询代码片段
export function getCodeSnippet(projectId: string, id: any) {
  return http.request({
    method: 'get',
    url: `${URL}/${projectId}/code-snippet/${id}`
  })
}

// 查询代码片段(树)
export function getCodeSnippetTree(projectId: string) {
  return http.request({
    method: 'get',
    url: `${URL}/${projectId}/code-snippet/tree`
  })
}

// 查询代码片段(列表)
export function getCodeSnippetList(projectId: string, data: any) {
  return http.request({
    method: 'post',
    url: `${URL}/${projectId}/code-snippet/query`,
    data
  })
}

// 删除代码片段
export function delCodeSnippet(projectId: string, id: any) {
  return http.request({
    method: 'delete',
    url: `${URL}/${projectId}/code-snippet/${id}`
  })
}
